// extracted by mini-css-extract-plugin
export default {"FavorateButton":"FavorateButton_FavorateButton__dS--B"};